export default {
      id: "youtube-usage",
      viewBox: "0 0 32 26",
      url: __webpack_public_path__ + "sprite.svg#youtube",
      toString: function () {
        return this.url;
      }
    }